import { Component, OnInit } from '@angular/core';
import { ConsultaService } from '../../services/consulta.service';
import { ProductosService } from '../../services/productos.service';
import { Router } from '@angular/router';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { URL_IMG } from '../../../conf/url.servicios';
import { ActivatedRoute } from '@angular/router';
import { resolve } from 'path';

declare var jquery: any;
declare var $: any;
declare var bootbox: any;

class Producto {
  id: any;
  idMarcaCategoria: any;
  clave: string;
  nombre: string;
  descripcion: string;
  precio: any;
  orden: any;
}

class RelacionImgProducto {
  idImagen: number;
  idProducto: number;
}

class Item {
  N_ESTATUS: any;
  N_ID: any;
  N_IDMARCA_CATEGORIA: any;
  N_IDSEXO: any;
  N_PRECIO: any;
  S_CLAVE: any;
  S_DESCRIPCION: any;
  S_NOMBRE: any;
  S_RUTA: any;
  claveImg: any;
  descripcionImg: any;
  idImagen: any;
}



class ImagenTabla {
  clave: string;
  descripcion: string;
  ruta: string;
  tipo: number;
  id: number;
}

@Component({
  selector: 'app-administra-productos',
  templateUrl: './administra-productos.component.html',
  styleUrls: ['./administra-productos.component.css']
})
export class AdministraProductosComponent implements OnInit {

  idEliminar: any;
  idProducto: any;
  idImg: any;
  loading: boolean;
  extension: any;
  rutaEliminar: any;

  initItem(item): any {
    item = new Item();
    item.claveImg = "";
    item.descripcionImg = "";
    item.idImagen = "";
    item.N_ESTATUS = "";
    item.N_ID = "";
    item.N_IDMARCA_CATEGORIA = "";
    item.N_IDSEXO = "";
    item.N_PRECIO = "";
    item.S_CLAVE = "";
    item.S_DESCRIPCION
    item.S_NOMBRE = "";
    item.S_RUTA = "";
    return item;
  }


  rutaImagen = URL_IMG;
  title = "Administración de Productos";
  categorias: any = [];
  form: FormGroup;
  itemEdicion: Item;
  itemNew: Producto;
  categoria: any = {};

  constructor(private router: Router, private fb: FormBuilder, private consultaService: ConsultaService,
    private productosService: ProductosService, private activatedRoute: ActivatedRoute) {
    this.createForm();
  }

  ngOnInit() {
    if (!this.consultaService.esNuevaSession()) {
      this.activatedRoute.params.subscribe(params => {

        this.obtieneProductos(params['idCategoria']);



      });
      this.itemEdicion = this.initItem(this.itemEdicion);
      this.itemNew = this.initItem(this.itemNew);




    }
  }

  reloadProductos() {
    this.activatedRoute.params.subscribe(params => {
      this.obtieneProductos(params['idCategoria']);
    })
  }

  obtieneProductos(idCategoria: any) {
    this.productosService.obtieneProductos(idCategoria).then(resolve => {
      this.categorias = this.productosService.productos;

      this.productosService.obtieneCategoria(idCategoria).then(resolve=>{
        this.categoria = this.productosService.categoria;
        console.log("this.categoria",this.categoria);

        if (this.categorias.length <= 0) {
          bootbox.alert("No se encontraron resultados");
        }

      });



    });
  }

  initModalEdicion(item) {
    console.log("Item editar");
    console.log(item);
    this.itemEdicion = item;
  }

  initModalNew() {
    this.itemNew = new Producto();
    this.activatedRoute.params.subscribe(params => {
      this.itemNew.idMarcaCategoria = params['idCategoria'];
    })
    this.itemNew.clave = "";
    this.itemNew.nombre = "";
    this.itemNew.descripcion = "";
    this.itemNew.precio = "";
    this.itemNew.orden = "";
    this.itemNew.id = null;
  }

  goBack() {
    this.router.navigate(['/administraCategorias', 1]);
  }

  /**
 * Image form
 */
  createForm() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      avatar: null,
      carpeta: "productos"
    });
  }


  cambiarImagen() {
    this.rutaEliminar = this.itemEdicion.S_RUTA;
    this.itemEdicion.S_RUTA = "";
  }

  getNewFileName(formParam) {
    var fileNameAux = formParam.avatar.filename;
    this.extension = fileNameAux.split('.').pop();
    var valReplace = "." + this.extension;
    var newFileName = fileNameAux.replace(valReplace, "");
    return newFileName + Date.now() + "." + this.extension;
  }

  /**
  * File change
  * @param event
  */
  onFileChange(event) {
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.get('avatar').setValue({
          filename: file.name,
          filetype: file.type,
          value: reader.result.split(',')[1]
        })
      };
    }
  }

  isValidForm() {
    var valido = true;
    const formModel = this.form.value;

    if (formModel.name.length == 0 || formModel.avatar == null) {
      valido = false;
    }
    return valido;
  }

  actualizarImagen() {

    console.log("Editar");

    //Adjunta imagen

    var rutaImagen = "";
    const formModel = this.form.value;
    this.loading = true;
    console.log(formModel);
    formModel.avatar.filename = this.getNewFileName(formModel);

    //Borra ruta del servidor

    this.consultaService.borraImagen(this.rutaEliminar);

    //adjunta la imagen

    this.consultaService.guardarImagen(formModel).then(resolve => {
      console.log(resolve);
      if (resolve) {

        rutaImagen = this.consultaService.rutaImagen;

        //Guarda ruta imagen en tabla

        var imgTbl = new ImagenTabla();
        imgTbl.clave = "";
        imgTbl.descripcion = formModel.name;
        imgTbl.ruta = rutaImagen;
        imgTbl.tipo = 1;
        imgTbl.id = this.itemEdicion.idImagen;
        this.consultaService.actualizaImagenTabla(imgTbl).then(resolve => {
          bootbox.alert("<strong>Alerta</strong><br/><br/> Información guardada correctamente");
          this.reloadProductos();
        });
      }
    });

  }

  actualizarProducto() {
    this.productosService.actualizarProducto(this.itemEdicion).then(resolve => {
      this.reloadProductos();
      bootbox.alert("<strong>Alerta</strong><br/><br/> Datos guardados correctamente");
    });
  }

  eliminarProducto(item) {
    this.idEliminar = item.N_ID;
    bootbox.confirm("<strong>Alerta</strong><br/><br/>¿Desea eliminar el producto seleccionado?",
      function (result) {
        if (result) {
          $("#btn_eliminar").click();
        }
      });
  }

  eliminar() {
    this.productosService.eliminarProducto(this.idEliminar).then(resolve => {
      this.reloadProductos();
      bootbox.alert("<strong>Alerta</strong><br/><br/> Producto eliminado correctamente");
    });
  }

  guardarProducto() {
    console.log("Datos Blog a editar");
    console.log(this.itemNew);

    //Adjunta imagen

    var rutaImagen = "";
    const formModel = this.form.value;
    this.loading = true;
    console.log(formModel);
    formModel.avatar.filename = this.getNewFileName(formModel);
    this.consultaService.guardarImagen(formModel).then(resolve => {
      console.log(resolve);
      if (resolve) {
        rutaImagen = this.consultaService.rutaImagen;
        //Guarda ruta imagen en tabla
        var imgTbl = new ImagenTabla();
        imgTbl.clave = "";
        imgTbl.descripcion = formModel.name;
        imgTbl.ruta = rutaImagen;
        imgTbl.tipo = 1;
        this.consultaService.guardaImagenTabla(imgTbl).then(resolve => {
          this.idImg = this.consultaService.idImg;

          //Guarda blog

          if (this.itemNew.id == null) {
            console.log("Nuevo");
            console.log(this.itemNew);
            this.productosService.guardarProducto(this.itemNew).then(resolve => {
              this.idImg = this.consultaService.idImg;
              this.idProducto = this.productosService.idProducto;

              //Guarda la relacion imagen-blog

              var rel = new RelacionImgProducto();
              rel.idProducto = this.idProducto;
              rel.idImagen = this.idImg;
              this.productosService.guardaRelacionImgProducto(rel).then(resolve => {
                this.reloadProductos();
                bootbox.alert("<strong>Alerta</strong><br/><br/> Información guardada correctamente");
              });

            });
          }

        });
      } else {
        alert('Ocurrió un error al subir la imagen, favor de intentar nuevamente');
      }

    });
  }


  imagenesProducto(item: any){
    console.log(item);
    this.router.navigate(['/administraImgProducto', item.N_ID , item.S_NOMBRE,item.N_IDMARCA_CATEGORIA]);
  }
}



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/app/components/administra-productos/administra-productos.component.ts